import { registerFunctionalComponent } from 'js/lib/components/component'

registerFunctionalComponent('.js-c-form-input-checkbox', 'InputCheckbox', InputCheckbox)

function InputCheckbox(component) {
  const icon = component.element.querySelector('.js-c-form-input-checkbox__icon')
  const button = component.element.querySelector('.js-c-form-input-checkbox__button')
  const input = component.element.querySelector('.js-c-form-input-checkbox__input')

  component.useHandler(() => {
    button.addEventListener('click', toggleCheckboxState)
    return () => button.removeEventListener('click', toggleCheckboxState)
  })

  function toggleCheckboxState() {
    icon.classList.toggle('hidden')
    const isChecked = button.getAttribute('aria-checked') === 'true'
    button.setAttribute('aria-checked', isChecked ? 'false' : 'true')
    button.setAttribute('data-state', isChecked ? 'unchecked' : 'checked')

    input.checked = !isChecked
  }
}
